export default "__VITE_ASSET__C25EC8Ap__"